export default [
  {
    path: '/static-h5',
    component: () => import('./page.vue'),
    meta: { title: '单配置页面' },
  },
]
